const normalizeCamel = str => str.replace(/[a-z]([A-Z])/g, found => `${found[0]} ${found[1].toLowerCase()}`);

export const camel = str => {
  return str.replace(/(?:-|_|\s)+?(\w)/g, (_, first) => first.toUpperCase());
};
export const dash = str => {
  return normalizeCamel(str).replace(/(?:_|\s)/g, '-');
};
export const snake = str => {
  return normalizeCamel(str).replace(/(?:-|\s)/g, '_');
};
export const normalize = str => {
  return normalizeCamel(str).replace(/(?:-|_)/g, ' ');
};
export const capitalize = str => {
  return normalizeCamel(str).replace(/(?:-|_|\s)+?(\w)/g, (_, capital) => ` ${capital.toUpperCase()}`).replace(/^([a-z])/, (_, capital) => `${capital.toUpperCase()}`);
};